/**
 * TransferDom directive for Vue 2
 * Moves an element to document.body to escape parent stacking context.
 * Solves: position:fixed being constrained by ancestor transform/filter/opacity.
 * Usage: <div v-transfer-dom>...</div>
 */
export default {
  inserted(el) {
    if (el.parentNode !== document.body) {
      document.body.appendChild(el)
    }
  },
  unbind(el) {
    if (el.parentNode === document.body) {
      document.body.removeChild(el)
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/transfer-dom.js